const initialState = {
  currentPage: null,
  isOpen: false
};

export const pageViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_PAGE_VIEWER": {
      return initialState;
    }
    case "OPEN_PAGE_VIEWER": {
      return { ...state, ...action.viewer };
    }
    case "SET_CURRENT_PAGE_VIEWER": {
      return { ...state, currentPage: action.page };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/page-viewer.js